<template>
    <div>
        <dx-check-box :value="checkbox" text="Текущие записи" @value-changed="onValueChange" />
        <dx-button style="margin-left: 10px" @click="openSelectBankPopup" text="Выбор банка" />
    </div>
    <ai-grid-edit-wrapper
        @gridEditWrapperMounted="onGridEditWrapperMounted"
        ref="gridRef"
        :meta="meta"
        :args="args"
        :show-footer="false"
        :action="action"
        :hasntRoute="true"
    />
    <dx-popup :visible="selectBankPopup">
        <div style="height: 90%">
            <component :is="componentName" ref="bankRef" />

            <dx-button text="выбрать" @click="onBankSelected" />
            <dx-button text="закрыть" @click="selectBankPopup = false" />
        </div>
    </dx-popup>
</template>

<script setup>
import { DxCheckBox, DxButton, DxPopup } from 'devextreme-vue';
import { ref } from 'vue';

const componentName = ref();

defineProps({
    action: {
        type: Function,
        default: null,
    },
});

const onGridEditWrapperMounted = () => {
    gridRef.value.ref.gridInstance.on('focusedRowChanged', e => (focusedRow.value = e.row.data));
    gridRef.value.ref.gridInstance.on('editingStart', e => (focusedRow.value = e.data));
};

const focusedRow = ref();
const selectBankPopup = ref(false);
const checkbox = ref(true);
const gridRef = ref();
const bankRef = ref();
const meta = {
    keyExpr: 'kodbpol',
    title: 'Банки получателя',
    columns: [
        {
            name: 'npp',
            caption: '№ п/п',
            dataField: 'npp',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 1,
            visible: true,
            fixed: true,
        },
        {
            name: 'rs',
            caption: 'Расчетный счет',
            dataField: 'rs',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 2,
            visible: true,
            fixed: true,
        },
        {
            name: 'ocher_plat',
            caption: 'Очередность платежа',
            dataField: 'ocher_plat',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 3,
            visible: true,
            fixed: true,
        },
        {
            name: 'name_bank',
            caption: 'Наименование банка',
            dataField: 'name_bank',
            allowEditing: false,
            editor: {},
            component: {},
            width: 350,
            index: 4,
            visible: true,
        },
        {
            name: 'filial',
            caption: 'Наименование филиала',
            dataField: 'filial',
            allowEditing: false,
            editor: {},
            component: {},
            width: 350,
            index: 5,
            visible: true,
        },
        {
            name: 'bic',
            caption: 'БИК',
            dataField: 'bic',
            allowEditing: false,
            editor: {},
            component: {},
            index: 6,
            visible: true,
        },
        {
            name: 'ks',
            caption: 'Кор. счет',
            dataField: 'ks',
            allowEditing: false,
            editor: {},
            component: {},
            index: 7,
            visible: true,
        },
        {
            name: 'adr',
            caption: 'Адрес банка',
            dataField: 'adr',
            allowEditing: false,
            editor: {},
            component: {},
            width: 350,
            index: 8,
            visible: true,
        },
        {
            name: 'p_ind',
            caption: 'Индекс',
            dataField: 'p_ind',
            allowEditing: false,
            editor: {},
            component: {},
            index: 9,
            visible: true,
        },
        {
            name: 'name_dep',
            caption: 'name_dep',
            dataField: 'name_dep',
            allowEditing: 'name_dep',
            editor: {},
            component: {},
            index: 10,
            visible: false,
        },
        {
            name: 'dep',
            caption: 'Отделение',
            dataField: 'dep',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'name_dep',
            },
            component: {
                name: 'bankpol-org-lookup',
                id: 'kodp',
                text: 'name',
            },
            width: 350,
            index: 25,
            visible: true,
        },
        {
            name: 'predel',
            caption: 'Минимальная сумма платежного док-та',
            dataField: 'predel',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 11,
            visible: true,
        },
        {
            name: 'pr_active',
            caption: 'Удален',
            dataField: 'pr_active',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 50,
            dataType: 'boolean',
            index: 12,
            visible: true,
        },
        {
            name: 'copys',
            caption: 'Кол-во копий при печати к реестру',
            dataField: 'copys',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 50,
            index: 13,
            visible: true,
        },
        {
            name: 'dat_otkr',
            caption: 'Дата открытия',
            dataField: 'dat_otkr',
            allowEditing: true,
            width: 100,
            index: 14,
            visible: true,
            dataType: 'date',
            format: 'dd.MM.yyyy',
        },
        {
            name: 'dat_fin',
            caption: 'Дата закрытия',
            dataField: 'dat_fin',
            allowEditing: true,
            width: 100,
            index: 15,
            visible: true,
            dataType: 'date',
            format: 'dd.MM.yyyy',
        },
        {
            name: 'remark',
            caption: 'Примечание',
            dataField: 'remark',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 16,
            visible: true,
        },
        {
            name: 'days_accept',
            caption: 'Кол-во дней для акцепта',
            dataField: 'days_accept',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 100,
            index: 17,
            visible: true,
        },
        {
            name: 'service',
            caption: 'Код услуги',
            dataField: 'service',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 100,
            index: 18,
            visible: true,
        },
        {
            name: 'kodbpol',
            caption: 'kodbpol',
            dataField: 'kodbpol',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 19,
            visible: false,
        },
        {
            name: 'kodb',
            caption: 'kodb',
            dataField: 'kodb',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 20,
            visible: false,
        },
        {
            name: 'nvar',
            caption: 'nvar',
            dataField: 'nvar',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 23,
            visible: false,
        },
        {
            name: 'pay_type',
            caption: 'pay_type',
            dataField: 'pay_type',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 24,
            visible: false,
        },
        {
            name: 'kod_parent',
            caption: 'kod_parent',
            dataField: 'kod_parent',
            allowEditing: 'kod_parent',
            editor: {},
            component: {},
            width: 250,
            index: 29,
            visible: false,
        },
    ],
    api: {
        select: 'nsi./nsi/view-ks-bankpol/select/get',
        save: 'nsi./nsi/view-ks-bankpol/save/set',
    },
    viewId: 'ks-bankpol-view',
};
const args = {
    select: {
        select_args: {
            ndep: null,
            active: checkbox.value,
        },
    },
};

const onValueChange = async e => {
    checkbox.value = e.value;
    args.select.select_args.active = e.value;

    await gridRef.value.ref.setDataSource(false);
};

const onBankSelected = async () => {
    const row = bankRef.value.focusedRow;
    const key = gridRef.value.ref.gridInstance.option('focusedRowKey');
    const index = gridRef.value.ref.gridInstance.option('focusedRowIndex');
    const data = await gridRef.value.ref.gridInstance.byKey(key);
    gridRef.value.ref.gridInstance.cellValue(index, 'kodb', row.kodb);
    gridRef.value.ref.gridInstance.cellValue(index, 'name_bank', row.name);
    gridRef.value.ref.gridInstance.cellValue(index, 'filial', row.filial);
    gridRef.value.ref.gridInstance.cellValue(index, 'bic', row.bic);
    gridRef.value.ref.gridInstance.cellValue(index, 'ks', row.ks);
    gridRef.value.ref.gridInstance.cellValue(index, 'adr', row.adr);
    gridRef.value.ref.gridInstance.cellValue(index, 'p_ind', row.p_ind);
    gridRef.value.ref.gridInstance.cellValue(index, 'kod_parent', row.kod_parent);
    gridRef.value.ref.gridInstance.cellValue(index, 'pr_active', row.pr_active);
    selectBankPopup.value = false;
};

const openSelectBankPopup = () => {
    selectBankPopup.value = true;
    componentName.value = 'ks-bank-view';
};

defineExpose({
    focusedRow,
    componentRef: gridRef,
});
</script>

<script>
export default {
    name: 'ks-bankpol-view',
};
</script>

<style scoped></style>
